<template>
  <div class="wrap">
    <Drawer :title="title" :visible="visible" :before-close="close" :wrapper-closable="false">
      <search-mode-config ref="config" />
      <template v-slot:footer>
        <el-button class="drawer-footer-btn" type="primary" @click="submitForm">确认</el-button>
        <el-button class="drawer-footer-btn" @click="close">返回</el-button>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/drawer';
import SearchModeConfig from './searchModeConfig.vue';
import { SEARCH_MODE } from '@/utils/constant';

export default {
  name: 'EditAgentAppDetail',
  components: { Drawer, SearchModeConfig },
  props: {
    dataset: {type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      rerankingModelList: [],
      textEmbeddingModelList: [],
    };
  },
  computed: {
    isEdit() {
      return this.type === 'edit';
    },
    title() {
      return SEARCH_MODE[this.dataset?.search_mode];
    },
  },
  watch: {
    visible() {
      this.$refs?.form?.clearValidate();
      if (this.visible) {
        this.$nextTick(()=>{
          this.$refs.config.setFormData(this.dataset);
        });
      }
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submitForm() {
      this.$refs.config.validate((valid) => {
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          this.$emit('resetSearchMode', this.$refs.config.getFormData());
          this.close();
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
.drawer-footer-btn {
  margin-left: 8px;
}
</style>
